<template>
    <div class="speaker">
        <div class="speakerHeader noselect" @click="openBio = !openBio">
            <h3 class="bodyL">{{ speaker.presentation_title }}</h3>
            <IconPlus :minus="openBio" />
        </div>
        <div :class="['speakerBio', { noimage: !speaker.avatar }]">
            <div class="avatar" v-if="speaker.avatar">
                <Image :image="speaker.avatar" :width="80" :height="80" :mobileHeight="120" :mobileWidth="120" imageClass="cover" />
            </div>
            <div class="info">
                <div class="name helvetica title6">{{ speaker.name }}</div>
                <div class="role bodyS" v-html="speaker.role"></div>
            </div>
        </div>
        <NCollapseTransition :show="openBio">
            <div class="bio bodyS" v-html="speaker.biography"></div>
            <div class="downloadsCont" v-if="speaker.downloads && speaker.downloads.length > 0">
                <template v-for="download in speaker.downloads">
                    <a class="helvetica" :href="`${directusUrl}/assets/${download.directus_files_id.id}`" target="_blank" rel="noopener noreferrer">
                        <IconDownload />
                        {{ download.directus_files_id.title }}
                    </a>
                </template>
            </div>
        </NCollapseTransition>
    </div>
</template>

<script lang="ts" setup>
import { NCollapseTransition } from 'naive-ui';
const directusUrl = useDirectusUrl()
const openBio = ref(false)

const props = defineProps<{ speaker: any }>()
</script>

<style lang="scss" scoped>
.speaker {
    border-top: var(--size-thickness) solid var(--color-primary);
    padding-top: var(--size-gutter-double);

    .speakerHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;

        cursor: pointer;

        h3 {
            color: var(--color-primary);
        }
    }

    .speakerBio {
        padding-top: var(--size-gutter-default);

        display: grid;
        grid-template-columns: fit-content 1fr;
        gap: var(--size-gutter-default);
        align-items: center;

        .avatar {
            position: relative;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
        }

        .role {
            text-wrap: balance;
        }

        &.noimage {
            grid-template-columns: 1fr min-content;
        }
    }

    .bio {
        padding-top: var(--size-gutter-default);

        display: flex;
        flex-direction: column;
        gap: var(--text-line-bodys);

        &:deep(video) {
            display: block;
            width: 100% !important;
            max-width: var(--text-maxwidth-body);
            height: auto !important;
            aspect-ratio: 16 / 9;
            background-color: black;
        }
    }

    .downloadsCont {
        margin-top: var(--text-line-bodys);

        a {
            text-decoration: none;
            color: var(--color-text-light);
            text-wrap: balance;

            display: flex;
            align-items: baseline;
            gap: var(--size-gutter-small);
        }
    }
}

@media screen and (max-width: 1200px) {
    .speaker {
        .speakerBio {
            .avatar {
                width: 60px;
                height: 60px;
            }
        }
    }
}
</style>